import { render, staticRenderFns } from "./AddCommentDialog.vue?vue&type=template&id=85365ea4"
import script from "./AddCommentDialog.vue?vue&type=script&lang=js"
export * from "./AddCommentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports